export type AdminNavigation = 'vertical' | 'top' | 'bottom';
export interface AdminAppearance {
    color: string;
    mode: 'light' | 'dark';
    navigation: AdminNavigation;
    menu: 'light' | 'dark';
    density: 'comfortable' | 'compact';
    width: 'fluid' | 'boxed';
}
export const APPEARANCE_KEY = 'comarca.admin.cowork.appearance.v1';
export const DEFAULT_APPEARANCE: AdminAppearance = {
    color: '#61257b', mode: 'light', navigation: 'vertical', menu: 'light', density: 'comfortable', width: 'fluid',
};
export const BRAND_COLORS = [
    {color:'#3564db',label:'Azul CO MARCA'},
    {color:'#c1348b', label:'Magenta CO MARCA'}, {color:'#61257b',label:'Morado CO MARCA'},
    {color:'#ea8406',label:'Naranja CO MARCA'}, {color:'#8b3fa8',label:'Violeta CO MARCA'},
];
export function normalizeAppearance(value: unknown): AdminAppearance {
    const v = value && typeof value === 'object' ? value as Partial<AdminAppearance> : {};
    return {
        color: typeof v.color === 'string' && /^#[\da-f]{6}$/i.test(v.color) ? v.color.toLowerCase() : DEFAULT_APPEARANCE.color,
        mode: v.mode === 'dark' ? 'dark' : 'light',
        navigation: v.navigation === 'top' || v.navigation === 'bottom' ? v.navigation : 'vertical',
        menu: v.menu === 'light' ? 'light' : v.menu === 'dark' ? 'dark' : DEFAULT_APPEARANCE.menu,
        density: v.density === 'compact' ? 'compact' : 'comfortable',
        width: v.width === 'boxed' ? 'boxed' : 'fluid',
    };
}
export function readAppearance(): AdminAppearance {
    try { const saved=localStorage.getItem(APPEARANCE_KEY);if(saved)return normalizeAppearance(JSON.parse(saved));return {...DEFAULT_APPEARANCE}; }
    catch { return {...DEFAULT_APPEARANCE}; }
}
export function colorTokens(color: string) {
    const rgb = [1,3,5].map(i => parseInt(color.slice(i,i+2),16));
    // Filled brand controls keep the white label requested for every accent.
    return {rgb:rgb.join(', '), contrast: '#ffffff'};
}


/** Accent text keeps contrast against the actual card surface. */
export function harmonizedTheme(color:string,mode:'light'|'dark'){
 const rgb=(hex:string)=>[1,3,5].map(i=>parseInt(hex.slice(i,i+2),16));
 const hex=(values:number[])=>'#'+values.map(v=>Math.round(v).toString(16).padStart(2,'0')).join('');
 const mix=(base:string,tint:string,weight:number)=>hex(rgb(base).map((v,i)=>v*(1-weight)+rgb(tint)[i]*weight));
 const lum=(value:string)=>rgb(value).map(v=>{const n=v/255;return n<=.04045?n/12.92:((n+.055)/1.055)**2.4;}).reduce((n,v,i)=>n+v*[.2126,.7152,.0722][i],0);
 const surface=mode==='dark'?'#1e2533':'#ffffff';
 const reference=color.toLowerCase()==='#61257b';const soft=reference?(mode==='dark'?'#342b45':'#f2eaf7'):mix(mode==='dark'?'#303748':'#ffffff',color,mode==='dark'?.12:.07),hero=mix(surface,color,mode==='dark'?.20:.09);
 const contrast=(value:string)=>Math.min(...[surface,soft,hero].map(bg=>(Math.max(lum(value),lum(bg))+.05)/(Math.min(lum(value),lum(bg))+.05)));
 let link=reference&&mode==='dark'?'#c29cde':color;for(let step=1;contrast(link)<4.5&&step<=20;step++)link=mix(color,mode==='dark'?'#ffffff':'#000000',step/20);
 return{link,dark:mix(color,'#000000',.22),soft,hero};
}
